/* GSM Reparatie Purmerend - telefoon productpagina (V5) */
(function () {
'use strict';
function norm(s) { return String(s == null ? '' : s).trim(); }
function splitParts(v) { var p = String(v).split('|'); return [norm(p[0]), norm(p.slice(1).join('|'))]; }
function formatMoney(cents, format) {
var value = '';
var m = /\{\{\s*(\w+)\s*\}\}/.exec(format || '€{{amount_with_comma_separator}}');
function fmt(n, dec, thou, decSep) {
var fixed = (n / 100).toFixed(dec).split('.');
var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
return dec ? whole + decSep + fixed[1] : whole;
}
switch (m ? m[1] : 'amount_with_comma_separator') {
case 'amount': value = fmt(cents, 2, ',', '.'); break;
case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
default: value = fmt(cents, 2, '.', ',');
}
return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/, value);
}
function init(root) {
if (root.hasAttribute('data-grp-ready')) return;
root.setAttribute('data-grp-ready', '');
var dataEl = root.querySelector('[data-grp-json]');
if (!dataEl) return;
var data;
try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[GRP] productdata kon niet gelezen worden', e); return; }
var variants = data.variants || [];
var split = typeof data.split === 'number' ? data.split : -1;
var money = function (c) { return formatMoney(c, data.moneyFormat); };
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var current = variants.filter(function (v) { return v.id === data.current; })[0] || variants[0];
if (!current) return;
function fromVariant(v) {
return v.options.map(function (val, i) { return i === split ? splitParts(val) : norm(val); });
}
function clone(s) { return s.map(function (x) { return Array.isArray(x) ? x.slice() : x; }); }
function skeleton(n) { var s = []; for (var i = 0; i < n; i++) s.push(i === split ? [null, null] : null); return s; }
function matches(v, s) {
for (var i = 0; i < s.length; i++) {
if (s[i] == null) continue;
if (i === split) {
var p = splitParts(v.options[i]);
if (s[i][0] != null && p[0] !== s[i][0]) return false;
if (s[i][1] != null && p[1] !== s[i][1]) return false;
} else if (norm(v.options[i]) !== s[i]) return false;
}
return true;
}
function exact(s) { for (var i = 0; i < variants.length; i++) if (matches(variants[i], s)) return variants[i]; return null; }
function withValue(s, i, part, val) { var c = clone(s); if (part === null) c[i] = val; else c[i][part] = val; return c; }
function score(v, s) {
var vs = fromVariant(v), n = 0;
for (var i = 0; i < s.length; i++) {
if (i === split) { if (vs[i][0] === s[i][0]) n++; if (vs[i][1] === s[i][1]) n++; }
else if (vs[i] === s[i]) n++;
}
return n;
}
function best(s, i, part, val, onlyAvailable) {
var filter = withValue(skeleton(s.length), i, part, val);
var c = variants.filter(function (v) { return matches(v, filter) && (!onlyAvailable || v.available); });
c.sort(function (a, b) { return (score(b, s) - score(a, s)) || (a.price - b.price); });
return c[0] || null;
}
var sel = fromVariant(current);
var buttons = [].slice.call(root.querySelectorAll('[data-grp-value]'));
var groups = [].slice.call(root.querySelectorAll('[data-grp-group]'));
function info(b) {
var p = b.getAttribute('data-part');
return { i: parseInt(b.getAttribute('data-option-index'), 10), part: p === '' || p == null ? null : parseInt(p, 10), val: norm(b.getAttribute('data-grp-value')) };
}
function selected(i, part) { return part === null ? sel[i] : (sel[i] ? sel[i][part] : null); }
/* ---------- Galerij ---------- */
var track = root.querySelector('[data-grp-track]');
var slides = track ? [].slice.call(track.children) : [];
var dots = [].slice.call(root.querySelectorAll('[data-grp-dot]'));
var thumbs = [].slice.call(root.querySelectorAll('[data-grp-thumb]'));
var activeEl = slides[0] || null;
function vis() { return slides.filter(function (s) { return !s.hidden; }); }
function setActiveEl(el) {
activeEl = el;
var n = slides.indexOf(el);
dots.forEach(function (d) { var k = parseInt(d.getAttribute('data-grp-dot'), 10); d.classList.toggle('is-active', k === n); d.setAttribute('aria-current', k === n ? 'true' : 'false'); });
thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-grp-thumb'), 10) === n); });
}
function goToEl(el, instant) {
if (!track || !el) return;
var left = el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
track.scrollTo({ left: left, behavior: instant || reduce ? 'auto' : 'smooth' });
setActiveEl(el);
}
function goTo(n, instant) { var v = vis(); if (!v.length) return; n = (n + v.length) % v.length; goToEl(v[n], instant); }
function curIndex() { var i = vis().indexOf(activeEl); return i < 0 ? 0 : i; }
if (track) {
var ticking = false;
track.addEventListener('scroll', function () {
if (ticking) return;
ticking = true;
requestAnimationFrame(function () {
ticking = false;
var tl = track.getBoundingClientRect().left, best = null, bd = Infinity;
vis().forEach(function (s) { var d = Math.abs(s.getBoundingClientRect().left - tl); if (d < bd) { bd = d; best = s; } });
if (best && best !== activeEl) setActiveEl(best);
});
}, { passive: true });
track.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { e.preventDefault(); goTo(curIndex() + 1); }
if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(curIndex() - 1); }
});
}
var prev = root.querySelector('[data-grp-prev]');
var next = root.querySelector('[data-grp-next]');
if (prev) prev.addEventListener('click', function () { goTo(curIndex() - 1); });
if (next) next.addEventListener('click', function () { goTo(curIndex() + 1); });
dots.concat(thumbs).forEach(function (b) {
b.addEventListener('click', function () {
var idx = parseInt(b.getAttribute('data-grp-dot') || b.getAttribute('data-grp-thumb'), 10);
if (slides[idx]) goToEl(slides[idx]);
});
});
function showVariantMedia(v) {
if (!v || !v.media || !slides.length) return;
for (var k = 0; k < slides.length; k++) {
if (!slides[k].hidden && String(slides[k].getAttribute('data-media-id')) === String(v.media)) { goToEl(slides[k]); return; }
}
}
/* ---------- Foto's per kleur (alt-tekst = kleurnaam) ---------- */
var colorIdx = -1;
(data.optionNames || []).forEach(function (n, i) { var l = String(n).toLowerCase(); if (colorIdx < 0 && (l.indexOf('kleur') > -1 || l.indexOf('color') > -1 || l.indexOf('colour') > -1)) colorIdx = i; });
var colorVals = {};
if (colorIdx > -1) variants.forEach(function (v) { colorVals[norm(v.options[colorIdx]).toLowerCase()] = true; });
var lastColor = null;
function applyColor(v) {
if (colorIdx < 0 || !slides.length || !v) return;
var c = norm(v.options[colorIdx]).toLowerCase();
if (c === lastColor) return;
lastColor = c;
var alt = function (s) { return norm(s.getAttribute('data-grp-alt')).toLowerCase(); };
var any = slides.some(function (s) { return alt(s) === c; });
var own = null; if (v.media) slides.forEach(function (s) { if (!own && String(s.getAttribute('data-media-id')) === String(v.media)) own = s; });
slides.forEach(function (s) { var a = alt(s); s.hidden = s !== own && any && colorVals[a] === true && a !== c; });
dots.forEach(function (d) { var s = slides[parseInt(d.getAttribute('data-grp-dot'), 10)]; d.hidden = !!(s && s.hidden); });
thumbs.forEach(function (t) { var s = slides[parseInt(t.getAttribute('data-grp-thumb'), 10)]; t.hidden = !!(s && s.hidden); });
var first = (own && !own.hidden) ? own : vis()[0];
if (first) goToEl(first, true);
}
/* ---------- Weergave bijwerken ---------- */
var priceEls = [].slice.call(root.querySelectorAll('[data-grp-price]'));
var compareEl = root.querySelector('[data-grp-compare]');
var saveEl = root.querySelector('[data-grp-save]');
var summaryEls = [].slice.call(root.querySelectorAll('[data-grp-summary]'));
var idInput = root.querySelector('[data-grp-id]');
var buyBtn = root.querySelector('[data-grp-buy]');
var stockEl = root.querySelector('[data-grp-stock]');
var stockText = root.querySelector('[data-grp-stocktext]');
var condCard = root.querySelector('[data-grp-condcard]');
var condName = root.querySelector('[data-grp-condname]');
var condGrids = [].slice.call(root.querySelectorAll('[data-grp-cond]'));
var designMode = !!(window.Shopify && window.Shopify.designMode);
function labelFor(i, part, val) {
for (var k = 0; k < buttons.length; k++) {
var x = info(buttons[k]);
if (x.i === i && x.part === part && x.val === val) return buttons[k].getAttribute('data-grp-label') || val;
}
return val;
}
function render(fromUser) {
applyColor(current);
buttons.forEach(function (b) {
var x = info(b);
var isSel = selected(x.i, x.part) === x.val;
var s = withValue(sel, x.i, x.part, x.val);
var v = exact(s);
var anyAvail = best(sel, x.i, x.part, x.val, true);
var ok = !!(v && v.available);
b.classList.toggle('is-selected', isSel);
b.setAttribute('aria-pressed', isSel ? 'true' : 'false');
b.classList.toggle('is-muted', !ok && !isSel);
b.disabled = !anyAvail && !isSel;
var extra = b.querySelector('[data-grp-extra]');
if (extra) {
var t = '';
extra.classList.remove('is-out');
if (!isSel) {
if (ok) {
var d = v.price - current.price;
if (d > 0) t = '+ ' + money(d);
else if (d < 0) t = String.fromCharCode(8722) + ' ' + money(-d);
} else if (!anyAvail) { t = 'Uitverkocht'; extra.classList.add('is-out'); }
}
extra.textContent = t;
}
var note = b.querySelector('[data-grp-note]');
if (note) note.textContent = anyAvail ? (ok || isSel ? 'Op voorraad' : 'Andere uitvoering') : 'Uitverkocht';
if (note && isSel && !current.available) note.textContent = 'Uitverkocht';
});
priceEls.forEach(function (el) { el.textContent = money(current.price); });
var hasCompare = current.compare && current.compare > current.price;
if (compareEl) { compareEl.hidden = !hasCompare; if (hasCompare) compareEl.textContent = money(current.compare); }
if (saveEl) { saveEl.hidden = !hasCompare; if (hasCompare) saveEl.textContent = 'Je bespaart ' + money(current.compare - current.price); }
var parts = [];
groups.forEach(function (g) {
var i = parseInt(g.getAttribute('data-option-index'), 10);
var p = g.getAttribute('data-part');
var part = p === '' || p == null ? null : parseInt(p, 10);
var val = selected(i, part);
if (val) parts.push(labelFor(i, part, val));
});
summaryEls.forEach(function (el) { el.textContent = parts.join(' ' + String.fromCharCode(183) + ' '); });
if (idInput) idInput.value = current.id;
if (buyBtn) {
buyBtn.disabled = !current.available;
buyBtn.textContent = current.available ? (data.buttonText || 'Toevoegen aan winkelwagen') : (data.soldOutText || 'Niet op voorraad');
}
if (stockEl) {
var q = current.qty;
var low = current.available && typeof q === 'number' && q > 0 && q <= (data.lowStock || 3);
stockEl.hidden = !low;
if (low && stockText) stockText.textContent = 'Nog maar ' + q + ' op voorraad in deze uitvoering';
}
if (condCard) {
var cond = split >= 0 && sel[split] ? String(sel[split][0]).toLowerCase() : '';
var shown = false;
condGrids.forEach(function (g) {
var match = cond && g.getAttribute('data-grp-cond') === cond && (g.getAttribute('data-has-img') === 'true' || designMode);
g.hidden = !match;
if (match) shown = true;
});
condCard.hidden = !shown;
if (condName && split >= 0 && sel[split]) condName.textContent = sel[split][0];
}
if (fromUser) {
showVariantMedia(current);
try {
var url = new URL(window.location.href);
url.searchParams.set('variant', current.id);
window.history.replaceState({}, '', url.toString());
} catch (e) { /* niets */ }
}
}
buttons.forEach(function (b) {
b.addEventListener('click', function () {
if (b.disabled) return;
var x = info(b);
var s = withValue(sel, x.i, x.part, x.val);
var v = exact(s);
if (!v || !v.available) {
var alt = best(s, x.i, x.part, x.val, true);
if (alt) v = alt;
else if (!v) v = best(s, x.i, x.part, x.val, false);
}
if (!v) return;
current = v;
sel = fromVariant(v);
render(true);
});
});
render(false);
if (current.media) {
for (var k = 0; k < slides.length; k++) {
if (!slides[k].hidden && String(slides[k].getAttribute('data-media-id')) === String(current.media)) { goToEl(slides[k], true); break; }
}
}
}
function initAll() { document.querySelectorAll('[data-grp-tp]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
else initAll();
document.addEventListener('shopify:section:load', initAll);
})();

/* V6: aangevinkte accessoires mee in de winkelwagen (telefoon/accessoire) */
(function () {
  'use strict';
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var root = form.closest && form.closest('[data-grp-tp]');
    if (!root || root.hasAttribute('data-grp-pp')) return;
    var extras = [].slice.call(root.querySelectorAll('[data-grp-addon]:checked'));
    if (!extras.length) return;
    var idEl = form.querySelector('[name="id"]');
    if (!idEl) return;
    e.preventDefault();
    var qEl = form.querySelector('[name="quantity"]');
    var items = [{ id: parseInt(idEl.value, 10), quantity: qEl ? (parseInt(qEl.value, 10) || 1) : 1 }];
    extras.forEach(function (x) { items.push({ id: parseInt(x.value, 10), quantity: 1 }); });
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = base + 'cart'; })
      .catch(function () { form.submit(); });
  }, true);
})();

/* V8: batterij, accessoires met korting, totaalprijs en snelle weergave */
(function () {
  'use strict';
  function fmt(c) { return '€' + (Math.round(c) / 100).toFixed(2).replace('.', ','); }
  function init(root) {
    if (root.hasAttribute('data-grp-v8')) return;
    root.setAttribute('data-grp-v8', '');
    var dataEl = root.querySelector('[data-grp-json]');
    var data = {}; try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    var priceEl = root.querySelector('.grp-tp__total [data-grp-price]');
    var batt = root.querySelector('[data-grp-batt]');
    var battInput = batt && batt.querySelector('[data-grp-batt-input]');
    var battExtra = batt ? (parseInt(batt.getAttribute('data-batt-price'), 10) || 0) : 0;
    var battLine = root.querySelector('[data-grp-batt-line]');
    var battAmount = root.querySelector('[data-grp-batt-amount]');
    var accLine = root.querySelector('[data-grp-acc-line]');
    var accLabel = root.querySelector('[data-grp-acc-label]');
    var accAmount = root.querySelector('[data-grp-acc-amount]');
    var sum = root.querySelector('[data-grp-summary]');
    if (battAmount) battAmount.textContent = '+ ' + fmt(battExtra);
    var busy = false;
    function variant() {
      var idEl = root.querySelector('form [name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : data.current;
      var vs = data.variants || [];
      for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i];
      return null;
    }
    function update() {
      if (busy) return; busy = true;
      var v = variant();
      var on = !!(battInput && battInput.checked);
      var accs = [].slice.call(root.querySelectorAll('[data-acc-input]:checked'));
      var accTotal = 0; accs.forEach(function (x) { accTotal += parseInt(x.getAttribute('data-price'), 10) || 0; });
      if (priceEl && v) priceEl.textContent = fmt(v.price + (on ? battExtra : 0) + accTotal);
      if (battLine) battLine.hidden = !on;
      if (accLine) {
        accLine.hidden = !accs.length;
        if (accLabel) accLabel.textContent = accs.length === 1 ? '1 accessoire met korting' : accs.length + ' accessoires met korting';
        if (accAmount) accAmount.textContent = '+ ' + fmt(accTotal);
      }
      if (sum) {
        var t = sum.textContent.replace(/ · Nieuwe batterij$/, '');
        sum.textContent = on ? t + ' · Nieuwe batterij' : t;
      }
      root.querySelectorAll('[data-acc-card]').forEach(function (c) {
        var i = c.querySelector('[data-acc-input]'); c.classList.toggle('is-added', !!(i && i.checked));
      });
      setTimeout(function () { busy = false; }, 0);
    }
    if (batt) batt.addEventListener('click', function (e) {
      var b = e.target.closest('[data-grp-batt-opt]'); if (!b) return;
      if (battInput) battInput.checked = b.getAttribute('data-grp-batt-opt') === '1';
      batt.querySelectorAll('[data-grp-batt-opt]').forEach(function (x) {
        var sel = x === b; x.classList.toggle('is-selected', sel); x.setAttribute('aria-pressed', sel ? 'true' : 'false');
      });
      update();
    });
    root.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-acc-input]')) update(); });
    [priceEl, sum].forEach(function (el) {
      if (el && 'MutationObserver' in window) new MutationObserver(function () { if (!busy) setTimeout(update, 0); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
    update();

    /* Snelle weergave */
    var acc = root.querySelector('[data-grp-acc]');
    if (!acc) return;
    var pct = parseInt(acc.getAttribute('data-pct'), 10) || 50;
    var modal, lastFocus, card, prod, chosen;
    function build() {
      modal = document.createElement('div');
      modal.className = 'grp-qv'; modal.hidden = true;
      modal.innerHTML = '<div class="grp-qv__backdrop" data-qv-close></div>' +
        '<div class="grp-qv__dialog" role="dialog" aria-modal="true" aria-labelledby="grp-qv-title">' +
        '<button type="button" class="grp-qv__close" data-qv-close aria-label="Sluiten">&times;</button>' +
        '<div class="grp-qv__media"><div class="grp-qv__main"><img alt="" data-qv-img></div><div class="grp-qv__thumbs" data-qv-thumbs></div></div>' +
        '<div class="grp-qv__info">' +
        '<span class="grp-qv__badge">-' + pct + '% bij je toestel</span>' +
        '<h3 class="grp-qv__title" id="grp-qv-title" data-qv-title></h3>' +
        '<div class="grp-qv__price"><s data-qv-was></s><b data-qv-now></b></div>' +
        '<div class="grp-qv__opts" data-qv-opts></div>' +
        '<div class="grp-qv__desc" data-qv-desc></div>' +
        '<button type="button" class="grp-qv__add" data-qv-add>Toevoegen aan mijn bestelling</button>' +
        '<a class="grp-qv__link" data-qv-link href="#">Volledige productpagina bekijken</a>' +
        '</div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-qv-close]')) return close();
        var t = e.target.closest('[data-qv-thumb]');
        if (t) { modal.querySelector('[data-qv-img]').src = t.getAttribute('data-src'); modal.querySelectorAll('[data-qv-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); }); return; }
        var o = e.target.closest('[data-qv-val]');
        if (o) { pickValue(parseInt(o.getAttribute('data-i'), 10), o.getAttribute('data-qv-val')); return; }
        if (e.target.closest('[data-qv-add]')) {
          var input = card.querySelector('[data-acc-input]');
          var willAdd = !(input.checked && String(input.value) === String(chosen.id));
          input.value = chosen.id;
          input.setAttribute('data-price', (chosen.price - Math.floor(chosen.price * pct / 100)));
          input.checked = willAdd;
          card.querySelector('[data-acc-was]').textContent = fmt(chosen.price);
          card.querySelector('[data-acc-now]').textContent = fmt((chosen.price - Math.floor(chosen.price * pct / 100)));
          var vEl = card.querySelector('[data-acc-variant]'); if (vEl && prod.variants.length > 1) vEl.textContent = chosen.title;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          close();
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
    }
    function sel() { return chosen.options ? chosen.options.slice() : []; }
    function pickValue(i, val) {
      var want = sel(); want[i] = val;
      var match = null;
      prod.variants.forEach(function (v) { if (!match && v.options.every(function (x, k) { return x === want[k]; })) match = v; });
      if (!match) prod.variants.forEach(function (v) { if (!match && v.options[i] === val && v.available) match = v; });
      if (match) { chosen = match; paint(); }
    }
    function paint() {
      modal.querySelector('[data-qv-was]').textContent = fmt(chosen.price);
      modal.querySelector('[data-qv-now]').textContent = fmt((chosen.price - Math.floor(chosen.price * pct / 100)));
      var opts = modal.querySelector('[data-qv-opts]'); opts.innerHTML = '';
      if (prod.variants.length > 1) prod.options.forEach(function (o, i) {
        var g = document.createElement('div'); g.className = 'grp-qv__group';
        var l = document.createElement('span'); l.className = 'grp-qv__label'; l.textContent = o.name + ': ' + chosen.options[i]; g.appendChild(l);
        var w = document.createElement('div'); w.className = 'grp-qv__vals';
        o.values.forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'grp-qv__val' + (chosen.options[i] === val ? ' is-selected' : '');
          b.setAttribute('data-qv-val', val); b.setAttribute('data-i', i); b.textContent = val; w.appendChild(b);
        });
        g.appendChild(w); opts.appendChild(g);
      });
      if (chosen.featured_image && chosen.featured_image.src) modal.querySelector('[data-qv-img]').src = chosen.featured_image.src;
      var input = card.querySelector('[data-acc-input]');
      var added = input.checked && String(input.value) === String(chosen.id);
      var btn = modal.querySelector('[data-qv-add]');
      btn.textContent = !chosen.available ? 'Niet op voorraad' : (added ? 'Verwijderen uit mijn bestelling' : 'Toevoegen aan mijn bestelling');
      btn.disabled = !chosen.available; btn.classList.toggle('is-remove', added);
    }
    function open(c, trigger) {
      card = c; lastFocus = trigger;
      if (!modal) build();
      var url = c.getAttribute('data-url');
      modal.querySelector('[data-qv-link]').href = url;
      modal.classList.add('is-loading'); modal.hidden = false;
      document.documentElement.classList.add('grp-qv-open');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
        prod = p;
        var input = c.querySelector('[data-acc-input]');
        chosen = null; p.variants.forEach(function (v) { if (String(v.id) === String(input.value)) chosen = v; });
        if (!chosen) chosen = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        modal.querySelector('[data-qv-title]').textContent = p.title;
        var imgs = (p.images || []).slice(0, 8);
        var main = modal.querySelector('[data-qv-img]'); main.src = imgs[0] ? imgs[0] + (imgs[0].indexOf('?') > -1 ? '&' : '?') + 'width=900' : '';
        var th = modal.querySelector('[data-qv-thumbs]'); th.innerHTML = '';
        if (imgs.length > 1) imgs.forEach(function (src, k) {
          var u = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
          var b = document.createElement('button'); b.type = 'button'; b.className = 'grp-qv__thumb' + (k === 0 ? ' is-active' : '');
          b.setAttribute('data-qv-thumb', ''); b.setAttribute('data-src', u); b.setAttribute('aria-label', 'Foto ' + (k + 1));
          var im = document.createElement('img'); im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160'; im.alt = ''; b.appendChild(im); th.appendChild(b);
        });
        var doc = new DOMParser().parseFromString(p.description || '', 'text/html');
        var txt = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
        modal.querySelector('[data-qv-desc]').textContent = txt.length > 420 ? txt.slice(0, 420).replace(/\s\S*$/, '') + '…' : txt;
        paint();
        modal.classList.remove('is-loading');
        var x = modal.querySelector('.grp-qv__close'); if (x) x.focus();
      }).catch(function () { window.location.href = url; });
    }
    function close() {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('grp-qv-open');
      setTimeout(function () { modal.hidden = true; }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    acc.addEventListener('click', function (e) {
      var t = e.target.closest('[data-acc-open]'); if (!t) return;
      e.preventDefault(); open(t.closest('[data-acc-card]'), t);
    });
  }
  function all() { document.querySelectorAll('[data-grp-tp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

/* V9: mobiel - compacte vaste fotobalk */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  function init(root) {
    if (root.hasAttribute('data-grp-v9') || root.hasAttribute('data-grp-pp')) return;
    var media = root.querySelector('.grp-tp__media');
    var grid = root.querySelector('.grp-tp__grid');
    if (!media || !grid) return;
    root.setAttribute('data-grp-v9', '');
    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'grp-mini';
    bar.setAttribute('aria-label', "Terug naar de foto's");
    bar.setAttribute('tabindex', '-1');
    bar.innerHTML = '<span class="grp-mini__img"><img alt=""></span>' +
      '<span class="grp-mini__text"><span class="grp-mini__title"></span><span class="grp-mini__sum"></span></span>' +
      '<span class="grp-mini__price"></span>';
    root.appendChild(bar);
    var img = bar.querySelector('img');
    var titleEl = bar.querySelector('.grp-mini__title');
    var sumEl = bar.querySelector('.grp-mini__sum');
    var priceEl = bar.querySelector('.grp-mini__price');
    var h1 = root.querySelector('h1');
    titleEl.textContent = h1 ? h1.textContent.trim() : '';
    function currentSlide() {
      var slides = [].slice.call(root.querySelectorAll('[data-grp-track] .grp-tp__slide')).filter(function (s) { return !s.hidden; });
      var dot = root.querySelector('[data-grp-dot].is-active');
      var all = [].slice.call(root.querySelectorAll('[data-grp-track] .grp-tp__slide'));
      if (dot) { var k = parseInt(dot.getAttribute('data-grp-dot'), 10); if (all[k] && !all[k].hidden) return all[k]; }
      return slides[0];
    }
    function refresh() {
      var s = currentSlide();
      var im = s && s.querySelector('img');
      if (im) { var src = im.currentSrc || im.src; if (img.getAttribute('src') !== src) img.src = src; }
      var sum = root.querySelector('[data-grp-summary]');
      sumEl.textContent = sum ? sum.textContent.trim() : '';
      var p = root.querySelector('.grp-tp__total [data-grp-price]');
      priceEl.textContent = p ? p.textContent.trim() : '';
    }
    var mediaOut = false, gridIn = true;
    function show() {
      var on = mq.matches && mediaOut && gridIn;
      if (on) { refresh(); place(); }
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.setAttribute('tabindex', on ? '0' : '-1');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { mediaOut = !en[0].isIntersecting; show(); }, { rootMargin: '-35% 0px 0px 0px' }).observe(media);
      new IntersectionObserver(function (en) { gridIn = en[0].isIntersecting; show(); }, { rootMargin: '0px 0px -60% 0px' }).observe(grid);
    }
    var t = null;
    function later() { clearTimeout(t); t = setTimeout(function () { if (bar.classList.contains('is-visible')) refresh(); }, 60); }
    if ('MutationObserver' in window) {
      new MutationObserver(later).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    }
    var header = document.querySelector('.grp-shop-header');
    var ticking = false;
    function place() {
      ticking = false;
      var top = 0;
      if (header) { var r = header.getBoundingClientRect(); top = Math.max(0, Math.round(r.bottom)); }
      bar.style.setProperty('--grp-mini-top', top + 'px');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } }, { passive: true, capture: true });
    if (mq.addEventListener) mq.addEventListener('change', show);
    bar.addEventListener('click', function () {
      media.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }
  function all() { document.querySelectorAll('[data-grp-tp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

/* V11: garantiezegel volgt de conditie (Premium = 24 maanden) */
(function () {
  'use strict';
  function init(root) {
    var seal = root.querySelector('[data-grp-seal]');
    if (!seal || seal.hasAttribute('data-ready')) return;
    seal.setAttribute('data-ready', '');
    var numEl = seal.querySelector('[data-grp-seal-num]');
    var base = seal.getAttribute('data-num'), alt = seal.getAttribute('data-num-new') || base;
    var data = {}; try { data = JSON.parse(root.querySelector('[data-grp-json]').textContent); } catch (e) {}
    var txt = seal.getAttribute('aria-label').replace(/^\S+\s*/, '');
    function update() {
      var idEl = root.querySelector('form [name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : data.current, v = null;
      (data.variants || []).forEach(function (x) { if (x.id === id) v = x; });
      var isNew = !!(v && v.options.join(' ').toLowerCase().indexOf('premium') > -1);
      var n = isNew ? alt : base;
      if (numEl && numEl.textContent !== n) numEl.textContent = n;
      seal.setAttribute('aria-label', n + ' ' + txt);
    }
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-grp-value]')) setTimeout(update, 30); });
    var sum = root.querySelector('[data-grp-summary]');
    if (sum && 'MutationObserver' in window) new MutationObserver(function () { setTimeout(update, 0); }).observe(sum, { childList: true, characterData: true, subtree: true });
    update();
  }
  function all() { document.querySelectorAll('[data-grp-tp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

/* V12: premium en accessoire - op telefoon/tablet de kleuren direct onder de foto's */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 989px)');
  if (!document.getElementById('grp-v12-css')) {
    var st = document.createElement('style'); st.id = 'grp-v12-css';
    st.textContent = '.grp-colors-moved{margin:-8px 0 0;padding:0 2px;border:0;min-width:0}';
    document.head.appendChild(st);
  }
  function init(root) {
    if (root.hasAttribute('data-grp-v12')) return;
    var isPremium = root.hasAttribute('data-grp-pp');
    var isAcc = root.classList.contains('grp-ta') || !!root.querySelector('.grp-ta') || !!root.closest('.grp-ta');
    if (!isPremium && !isAcc) return;
    var media = root.querySelector('.grp-pp__media, .grp-tp__media');
    if (!media) return;
    var data = {}; try { data = JSON.parse(root.querySelector('[data-grp-json]').textContent); } catch (e) {}
    var ci = -1;
    (data.optionNames || []).forEach(function (n, i) { var l = String(n).toLowerCase(); if (ci < 0 && (l.indexOf('kleur') > -1 || l.indexOf('color') > -1 || l.indexOf('colour') > -1)) ci = i; });
    var group = null;
    root.querySelectorAll('[data-grp-group]').forEach(function (g) { if (!group && ci > -1 && String(g.getAttribute('data-option-index')) === String(ci)) group = g; });
    if (!group) return;
    root.setAttribute('data-grp-v12', '');
    var mark = document.createComment('grp-kleuren');
    group.parentNode.insertBefore(mark, group);
    function place() {
      if (mq.matches) {
        if (group.previousSibling !== media && media.nextSibling !== group) media.parentNode.insertBefore(group, media.nextSibling);
        group.classList.add('grp-colors-moved');
      } else if (mark.parentNode && group.previousSibling !== mark) {
        mark.parentNode.insertBefore(group, mark.nextSibling);
        group.classList.remove('grp-colors-moved');
      }
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
  }
  function all() { document.querySelectorAll('[data-grp-tp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
